import {
  ClientFactory,
  IVerdragsbijdrageClient,
  VerdragsbijdrageOutputModel,
  ClientHelper
} from "@core/client";

import { stap10OverigInkomenSchemaModel } from "../flow/schema/Stap10OverigInkomen";
import { stap11OuderenkortingSchemaModel } from "../flow/schema/Stap11Ouderenkorting";
import { stap12AlleenstaandeOuderenkortingSchemaModel } from "../flow/schema/Stap12AlleenstaandeOuderenkorting";
import { stap13HeffingskortingSchemaModel } from "../flow/schema/Stap13Heffingskorting";
import { Stap1IngangsDatumSchemaModel } from "../flow/schema/Stap1IngangsDatum";
import { Stap2UwWoonlandSchemaModel } from "../flow/schema/Stap2UwWoonland";
import { Stap3UwGeboortedatumSchemaModel } from "../flow/schema/Stap3UwGeboortedatum";
import { Stap4HeeftUPartnerSchemaModel } from "../flow/schema/Stap4HeeftUPartner";
import { Stap5AGeboortedatumPartnerSchemaModel } from "../flow/schema/Stap5AGeboortedatumPartner";
import { stap5BGezinsledenMeeverzekerdSchemaModel } from "../flow/schema/Stap5BGezinsledenMeeverzekerd";
import { Stap6APartnerMeeverzekerenSchemaModel } from "../flow/schema/Stap6APartnerMeeverzekeren";
import { stap6BDatumMeeverzekeringGezinsledenSchemaModel } from "../flow/schema/Stap6BDatumMeeverzekeringGezinsleden";
import { stap7AGezinsledenMeeverzekerdSchemaModel } from "../flow/schema/Stap7AGezinsledenMeeverzekeren";
import { stap8ADatumMeeverzekeringGezinsledenSchemaModel } from "../flow/schema/Stap8ADatumMeeverzekeringGezinsleden";
import { stap9WettelijkPensioenUitkeringSchemaModel } from "../flow/schema/Stap9WettelijkPensioenUitkering";
import { BerekenVerdragsbijdrageMapper } from "../mapper/BerekenVerdragsbijdrage-mapper";
import { ActiveYearsModel } from "../domain/ActiveYearsModel";

export type VBRekenModel = Stap1IngangsDatumSchemaModel &
  Stap2UwWoonlandSchemaModel &
  Stap3UwGeboortedatumSchemaModel &
  Stap4HeeftUPartnerSchemaModel &
  Partial<Stap5AGeboortedatumPartnerSchemaModel> &
  Partial<stap5BGezinsledenMeeverzekerdSchemaModel> &
  Partial<Stap6APartnerMeeverzekerenSchemaModel> &
  Partial<stap6BDatumMeeverzekeringGezinsledenSchemaModel> &
  Partial<stap7AGezinsledenMeeverzekerdSchemaModel> &
  Partial<stap8ADatumMeeverzekeringGezinsledenSchemaModel> &
  stap9WettelijkPensioenUitkeringSchemaModel &
  stap10OverigInkomenSchemaModel &
  stap11OuderenkortingSchemaModel &
  stap12AlleenstaandeOuderenkortingSchemaModel &
  stap13HeffingskortingSchemaModel;

export class VBToolService {
  private readonly verdragsbijdrageClient: IVerdragsbijdrageClient;

  constructor(apiUrl: string) {
    const clientFactory = new ClientFactory(apiUrl);
    this.verdragsbijdrageClient = clientFactory.getClient();
  }

  getActiveYears = async (): Promise<ActiveYearsModel> => {
    return new Promise<ActiveYearsModel>((resolve, reject) => {
      this.verdragsbijdrageClient
        .actieveJaren()
        .then((response) => resolve(new ActiveYearsModel(response)))
        .catch((reason: any) => {
          reject(ClientHelper.getErrorMessage(reason));
        });
    });
  };

  verdragsbijdrageProefberekening = (values: VBRekenModel): Promise<VerdragsbijdrageOutputModel> => {
    const mapper = new BerekenVerdragsbijdrageMapper();
    const request = mapper.map(values);
    return new Promise<VerdragsbijdrageOutputModel>((resolve, reject) => {
      this.verdragsbijdrageClient
        .bereken(request)
        .then((response) => {
          resolve(response);
        })
        .catch((reason: any) => {
          reject(ClientHelper.getErrorMessage(reason));
        });
    });
  };

  woonlanden = (jaar: number): Promise<string[]> => {
    return new Promise<string[]>((resolve, reject) => {
      this.verdragsbijdrageClient
        .woonlanden(jaar)
        .then((response) => {
          resolve(response);
        })
        .catch((reason: any) => {
          reject(ClientHelper.getErrorMessage(reason));
        });
    });
  };

  berekeningPdf = (values: VBRekenModel): Promise<any> => {
    const mapper = new BerekenVerdragsbijdrageMapper();
    const request = mapper.map(values);
    return new Promise<any>((resolve, reject) => {
      this.verdragsbijdrageClient
        .export(request)
        .then((response) => {
          resolve(response.data);
        })
        .catch((reason: any) => {
          reject(ClientHelper.getErrorMessage(reason));
        });
    });
  };
}
